// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2Oma-","footer":"Form_footer__1rFI2"};